import React, { Component } from 'react';
import { connect } from 'react-redux'
import UsuariosPorPerfil from './UsuariosPorPerfil';

////Importación de actions.
import {
    getScreenData,
    resetStateUsrPorPerf,
    searchUser,
    setActivosCheckbox,
    setBloqueadosCheckbox,
    setEliminadosCheckbox,
    orderColumn,
    setAllCheckbox,
    setCheckbox,
    setUserState,
    setMotivoBloqueo
} from '../actions/UsuariosPorPerfil';

const mapStateToProps = (state) => {
    return {
        data: state.usuariosPorPerfil,
        concierge: state.concierge
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (id, currentScope, executionContext) => {
            dispatch(getScreenData(id, currentScope, executionContext));
        },
        resetStateUsrPorPerf: () => {
            dispatch(resetStateUsrPorPerf());
        },
        searchUser: (usuario) => {
            dispatch(searchUser(usuario));
        },
        setActivosCheckbox: (usuario) => {
            dispatch(setActivosCheckbox(usuario));
        },
        setBloqueadosCheckbox: (usuario) => {
            dispatch(setBloqueadosCheckbox(usuario));
        },
        setEliminadosCheckbox: (usuario) => {
            dispatch(setEliminadosCheckbox(usuario));
        },
        orderColumn: (usuario) => {
            dispatch(orderColumn(usuario));
        },
        setAllCheckbox: (allCheckboxFilter, currentUser) => {
            dispatch(setAllCheckbox(allCheckboxFilter, currentUser));
        },
        setCheckbox: (usuarioId) => {
            dispatch(setCheckbox(usuarioId));
        },
        setUserState: (id, activo, bloqueado) => {
            dispatch(setUserState(id, activo, bloqueado));
        },
        setMotivoBloqueo: (motivoBloqueo) => {
            dispatch(setMotivoBloqueo(motivoBloqueo));
        }
    }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(UsuariosPorPerfil);

export default Container;